/**
 * @param key 要获取的localStorage key
 * @returns {*} parse过的storage值
 */
export function getStorage(key) {
    let res = window.localStorage.getItem(key);

    try {
        res = JSON.parse(res);
    }
    catch (e) {
        // 返回值非json字符串，不处理，直接返回
    }

    return res;
}

/**
 * @param key 要添加/更新的localStorage key
 * @param value 要添加/更新的localStorage 值
 */
export function setStorage(key, value) {
    let parsedValue = value;

    if (typeof value !== 'string') {
        parsedValue = JSON.stringify(value);
    }
    window.localStorage.setItem(key, parsedValue);
}

/**
 * @param key 要删除的localStorage key
 */
export function removeStorage(key) {
    window.localStorage.removeItem(key);
}
